<template>
    <card :title="'Pending to Approve ' + dispenseErrorLabel + 's'">
        <DispenseErrorListComponent cards hide-status-filter mode="pending" />
    </card>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import DispenseErrorListComponent from '@/components/DispensingError/DispenseErrorListComponent.vue';

@Component({
    name: "PendingToAcceptErrorsPage",
    components: {
        DispenseErrorListComponent,
    },
})
export default class PendingToAcceptErrorsPage extends Vue {

    mounted() {
        this.fetchDispenseErrorLabel();
    }

    protected dispenseErrorLabel = "";

    async fetchDispenseErrorLabel() {
        try {
            const resp = await this.$http.get("/Configuration/DispenseErrorLabel");
            this.dispenseErrorLabel = resp.data?.trim();
        } catch {
            this.dispenseErrorLabel = "Error";
            //ignore
        }
    }

}
</script>